import type { CSSProperties } from 'react';

export type TearDropCorner = 'nw' | 'ne' | 'sw' | 'se';

type TearDropCornerHandleProps = {
  corner: TearDropCorner;
  /** Logical px — matches Mobile TearDropCornerHandle default 22. */
  size?: number;
  color?: string;
  strokeColor?: string;
};

/**
 * Web port of Mobile2 TearDropCornerHandle / ImagePreprocessModal drawCornerHandle.
 * SVG: large-arc=1, sweep=0 for the outer teardrop lobe.
 */
export function TearDropCornerHandle({
  corner,
  size = 22,
  color = '#2563eb',
  strokeColor = '#ffffff',
}: TearDropCornerHandleProps) {
  const scaleX = corner === 'ne' || corner === 'se' ? -1 : 1;
  const scaleY = corner === 'sw' || corner === 'se' ? -1 : 1;
  const extent = size * 2 + 4;
  const d = `M 0 0 L 0 ${-size} A ${size} ${size} 0 1 0 ${-size} 0 Z`;

  const positionStyle: CSSProperties = {
    position: 'absolute',
    width: 0,
    height: 0,
    overflow: 'visible',
    pointerEvents: 'none',
    ...(corner === 'nw' || corner === 'sw' ? { left: 0 } : { right: 0 }),
    ...(corner === 'nw' || corner === 'ne' ? { top: 0 } : { bottom: 0 }),
  };

  return (
    <div style={positionStyle} aria-hidden>
      <svg
        width={extent * 2}
        height={extent * 2}
        viewBox={`${-extent} ${-extent} ${extent * 2} ${extent * 2}`}
        style={{ position: 'absolute', left: -extent, top: -extent }}
      >
        <g transform={`scale(${scaleX} ${scaleY})`}>
          <path
            d={d}
            fill={color}
            stroke={strokeColor}
            strokeWidth={2}
            strokeLinejoin="round"
            strokeLinecap="round"
          />
        </g>
      </svg>
    </div>
  );
}
